const SELECTORS = {
	checkboxTrigger: '[data-checkbox-collapse-trigger]',
	collapseElement: '[data-checkbox-collapse-element]',
};

const CLASSES = {
	hidden: 'hidden',
};

export class CheckboxCollapse {
	constructor() {
		this.checkboxTriggers = [...document.querySelectorAll(SELECTORS.checkboxTrigger)];
		this.collapseElements = [...document.querySelectorAll(SELECTORS.collapseElement)];

		// Only proceed if we have at least one trigger and one element
		if (this.checkboxTriggers.length === 0 || this.collapseElements.length === 0) {
			return;
		}

		this.bindEvents();
		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new CheckboxCollapse();
	}

	/**
	 * Bind `this` explicitly for event listeners.
	 */
	bindEvents() {
		['onChange'].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	hide() {
		this.collapseElements.forEach((item) => {
			item.classList.add(CLASSES.hidden);
		});
	}

	static show(item) {
		item.classList.remove(CLASSES.hidden);
	}

	onChange(event) {
		const checkbox = event.target;
		const checkboxName = checkbox.name;

		// Only affect elements that match this specific checkbox's name
		this.collapseElements.forEach((item) => {
			const elementValue = item.getAttribute('data-checkbox-collapse-element');

			if (elementValue === checkboxName) {
				if (checkbox.checked) {
					CheckboxCollapse.show(item);
				} else {
					item.classList.add(CLASSES.hidden);
				}
			}
		});
	}

	setupEventListeners() {
		this.checkboxTriggers.forEach((checkbox) => checkbox.addEventListener('change', this.onChange));
	}

	setup() {
		this.setupEventListeners();
	}

	destroy() {
		this.checkboxTriggers.forEach((checkbox) =>
			checkbox.removeEventListener('change', this.onChange)
		);
	}
}
